import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import CreateTeamFields from "./CreateTeamFields";
import { selectCmsControlByType } from "../../../../../../redux/slices/cmsSettingsSlice";

const ConnectedCreateTeamFields = () => {
    const {
        ENUMS: {
            CMS_Control: { P2P_REGISTRATION_CONTENT },
        },
    } = constants;
    const control = useSelector((state) =>
        selectCmsControlByType(P2P_REGISTRATION_CONTENT, state),
    );

    const {
        options: {
            createTeamModal: {
                teamFundraisingGoalDescription = "And don’t worry, funds raised by team members will count towards their own personals goal AND the collective team goal!",
                teamFundraisingGoalHeading = "How much does your team want to raise?",
                teamNameHeading = "What do you want to name your team?",
            },
        },
    } = control;

    const createTeamFieldsProps = {
        teamFundraisingGoalDescription,
        teamFundraisingGoalHeading,
        teamNameHeading,
    };

    return <CreateTeamFields {...createTeamFieldsProps} />;
};

export default ConnectedCreateTeamFields;
